import { Costs } from "./types";
import { formatNumber } from "@/lib/utils";
import { quantityColumnWidth } from "../constants";
import useOperationListContext from "./useOperationListContext";
import useOperationContext from "./useOperationContext";

export default function CostColumns({
  costsOverride,
}: {
  costsOverride?: Costs;
}) {
  const { quantities } = useOperationListContext();
  const { operationData } = useOperationContext();
  const costs = costsOverride ?? operationData.costs;

  return (
    <div className="flex divide-x divide-slate-100 text-sm">
      {quantities.map((q, i) => (
        <div
          key={i}
          className="p-1 flex flex-col items-end justify-end gap-2 bg-slate-50"
          style={{
            maxWidth: quantityColumnWidth,
            minWidth: quantityColumnWidth,
          }}
        >
          <div className="flex flex-col items-end">
            {costs?.[q]?.total ? (
              <>
                <div className="truncate">
                  $ {formatNumber(costs[q].total.value, true)}
                </div>
                <div className="text-gray-500 truncate">
                  $ {formatNumber(Number(costs[q].total.value) / q, true)}
                </div>
              </>
            ) : (
              <>
                <div className="invisible">.</div>
                <div className="invisible">.</div>
              </>
            )}
          </div>
        </div>
      ))}
    </div>
  );
}
